<template>
  <van-popup v-model="onShow" position="bottom" class="pay-popup">
    <van-row align="center" class="pay-header">
      <van-col class="pay-subtitle">
        <span class="boxUnit">{{ orderData.CurrencySymbol }}</span>
        {{ orderData.TotalAmountDue }}
      </van-col>
      <van-col class="pay-title">{{ $t.order.payType }}</van-col>
    </van-row>

    <div class="payBottom">
      <van-radio-group v-model="paymentMethod">
        <van-cell-group>
          <van-cell
            v-for="(item, index) in paymentOptions"
            :key="index"
            :title="item.paymentName"
            clickable
            @click="onSelect(item)"
          >
            <template #icon>
              <img
                :src="require('@/assets/img/order/' + item.icon + '.png')"
                class="pay-icon"
              />
            </template>
            <template #right-icon>
              <van-radio :name="item.paymentMethod" checked-color="#009ed4"></van-radio>
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </div>

    <div class="submitBox" @click="onPay">
      <div class="submit">{{ $t.order.onPay }}</div>
    </div>
  </van-popup>
</template>
<script>
import Vue from "vue";
import { Cell, CellGroup, Popup, Radio, RadioGroup } from "vant";
Vue.use(Popup).use(Cell).use(CellGroup).use(Radio).use(RadioGroup);

export default {
  name: "PayWindow",
  props: ["orderData"],
  data() {
    return {
      paymentMethod: 1,
      paymentOptions: [
        {
          paymentName: this.$t.order.paymentOption1,
          paymentMethod: 1,
          icon: "alipay",
        },
        // {
        //   paymentName: this.$t.order.paymentOption2,
        //   paymentMethod: 2,
        //   icon: "wechat",
        // },
      ],
      onShow: false,
    };
  },
  created() {
    this.$bus.$off("showPayWindow").$on("showPayWindow", (isShow) => {
      this.onShow = isShow;
    });
  },
  methods: {
    onSelect(item) {
      this.paymentMethod = item.paymentMethod;
    },
    onPay() {
      this.paymentCollectionBill();
      this.onShow = false;
    },
    paymentCollectionBill() {
      this.$commonMethod.showLoading();
      let param = {
        WB_Number: this.orderData.WB_Number,
        PaymentMethod: this.paymentMethod,
      };
      this.$api.order
        .paymentCollectionBill(param)
        .then((res) => {
          const url = res.data;
          if (url) {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.gotoPay, {
              url: url,
            });
          }
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
            status: error.status,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
.pay-popup {
  height: auto;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  padding-bottom: env(safe-area-inset-bottom);
  .pay-header {
    width: auto;
    padding: 5%;
    .pay-title {
      width: 100%;
      text-align: center;
      font-size: 12px;
    }
    .pay-subtitle {
      width: 100%;
      text-align: center;
      font-weight: bold;
      font-size: 2rem;
      margin-top: 0.5rem;
      margin-bottom: 1rem;
      .boxUnit {
        font-size: 1.5rem;
        margin-left: 4px;
        margin-right: 4px;
      }
    }
  }
  .pay-icon {
    width: 25px;
    height: 25px;
    margin-right: 10px;
  }
  .submitBox {
    width: 100%;
    .submit {
      position: relative;
      width: 90%;
      margin: 5%;
      border-radius: 3rem;
      padding: 0.8rem 0;
      text-align: center;
      background: linear-gradient(left, #009ed4, #5029c3);
      color: #ffffff;
      font-size: 1rem;
      line-height: 1;
    }
  }
}
</style>
